module.exports = __webpack_public_path__ + "img/hiddenSearch.9bc0a15b.jpg";